import {createAsyncThunk} from "@reduxjs/toolkit";
import {apiInstanceV2} from "../../Apis/AxiosV2";
import { SERVICE_TYPE } from "../EndPoints";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */


export const GetAllServiceType = createAsyncThunk(
    'serviceTypeSection/getAllServiceType',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .get(SERVICE_TYPE.getAllServiceType, params?.pagination)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
// create department
export const CreateServiceType  = createAsyncThunk(
    'serviceTypeSection/createServiceType',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .post(SERVICE_TYPE.createServiceType, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// update department
export const UpdateServiceType  = createAsyncThunk(
    'serviceTypeSection/updateServiceType',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .put(SERVICE_TYPE.updateServiceType, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
// delete department
export const DeleteServiceType  = createAsyncThunk(
    'serviceTypeSection/deleteServiceType',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .delete(`${SERVICE_TYPE.deleteServiceType}${params}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const ListOfUsersServiceType  = createAsyncThunk(
    'serviceTypeSection/listOfUsersServiceType',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .post(`${SERVICE_TYPE.listOfUsersServiceType}${params?.id}`, params.pagination)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// list of all user not belong to department
export const GetAllNonServiceType  = createAsyncThunk(
    'serviceTypeSection/getAllNonServicetypeUser',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .get(`${SERVICE_TYPE.getAllNonServiceType}${params}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
